import { useState } from "react";
import api from "../api";

export interface SiaeValidationResponse {
  valid: boolean;
  nombreCompleto?: string;
  genero?: string;
  fechaNacimiento?: string;
  matricula?: string;
}

export function useSiaeValidation() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const validateMatricula = async (matricula: string): Promise<SiaeValidationResponse> => {
    setLoading(true);
    setError(null);

    try {
      const normalized = matricula.trim();
      const { data } = await api.post<SiaeValidationResponse>("/registrations/verify-siae", {
        matricula: normalized,
      });

      if (!data.valid) {
        setError("Matricula no valida o no activa.");
      }

      return data;
    } catch (error: any) {
      const status = error?.response?.status;
      const message =
        status === 429
          ? "Demasiados intentos. Espere 5 minutos."
          : status === 503
            ? "Servicio no disponible. Intente mas tarde."
            : error?.response?.data?.error || "No fue posible validar la matricula.";

      setError(message);
      throw new Error(message);
    } finally {
      setLoading(false);
    }
  };

  return { validateMatricula, loading, error, setError };
}
